import {
  plainleafSkinLabels,
  plainleafSkins,
  type PlainleafSkin,
} from "../lib/plainleaf_skin.ts";

export function PlainleafSkinPicker({
  skin,
  onChange,
  compact = false,
}: {
  skin: PlainleafSkin;
  onChange: (skin: PlainleafSkin) => void;
  compact?: boolean;
}) {
  return (
    <div
      class={`pl-skin-picker ${compact ? "is-compact" : ""}`}
      role="group"
      aria-label="界面皮肤"
    >
      {plainleafSkins.map((option) => (
        <button
          type="button"
          key={option}
          class={skin === option ? "is-active" : ""}
          aria-pressed={skin === option}
          onClick={() => onChange(option)}
        >
          <span class={`pl-skin-swatch is-${option}`} aria-hidden="true">
            <i />
          </span>
          <span>{plainleafSkinLabels[option]}</span>
        </button>
      ))}
    </div>
  );
}
